module.exports = __webpack_public_path__ + "img/green-icon-en(1).4c21858c.png";